import { render } from "./sepa.vue?vue&type=template&id=2da4fa0a&scoped=true&ts=true"
import script from "./sepa.vue?vue&type=script&lang=ts"
export * from "./sepa.vue?vue&type=script&lang=ts"

import "./sepa.vue?vue&type=style&index=0&id=2da4fa0a&lang=less"
import "./sepa.vue?vue&type=style&index=1&id=2da4fa0a&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da4fa0a"]])

export default __exports__